export const LOADING = 'loading'
export const SUCCEEDED = 'succeeded'
export const FAILED = 'failed'
export const IDLE = 'idle'
export const ERROR = 'error'
